import {
  LiveboardEmbed,
  RuntimeFilterOp,
} from '@thoughtspot/visual-embed-sdk/lib/src/react'
import cx from 'classnames'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { selectLeftPanelVisibility } from 'common/components/leftPanel/store/leftPanelSlice'
import PageContainer from 'common/components/PageContainer'
import { useAppSelector } from 'common/hooks/redux'

import LeftSection from './LeftSection'
import { EMBED_CLASS_NAME } from './styles'

export const Liveboard = () => {
  const liveboardId = process.env.REACT_APP_REPORTING_LIVEBOARD_ID
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const flags = useFlags()

  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  return (
    <div
      className={cx('relative overflow-y-auto overflow-x-hidden flex h-full', {
        'ml-30': leftPanelVisibility === 'hidden',
      })}
    >
      {flags.showSavedReports && <LeftSection />}
      <PageContainer>
        <LiveboardEmbed
          className={EMBED_CLASS_NAME}
          liveboardId={liveboardId}
          visibleActions={[]}
          runtimeFilters={[
            {
              columnName: 'Account ID',
              operator: RuntimeFilterOp.EQ,
              values: [accountId],
            },
          ]}
        />
      </PageContainer>
    </div>
  )
}
